import { render, staticRenderFns } from "./CheckSecret.vue?vue&type=template&id=6cb4e188&"
import script from "./CheckSecret.vue?vue&type=script&lang=js&"
export * from "./CheckSecret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports